/**
 * Dar Scripts
 *
 */

var deviceSupportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
var loader;
var $contentBlocks;
var contentBlockPositions = [];
var docHeight;
var scrollTimeout = false;


$(document).ready(function ($) {
  
    // document.addEventListener('focus', function() {
    //   console.log('focused: ', document.activeElement)
    // }, true);

    var $body = $('body');

    loader = $("#loader");

    if(deviceSupportsTouch) $body.addClass('touch-device');

    var firstFocusableElement, lastFocusableElement, focusableContent, previouslyFocusedElement;
    var desktopSubmenuReturnFocus = null;
    var mobileSubmenuOpenerButton = null;
    var $desktopTabindexPatched = $();
    var $mobileTabindexPatched = $();

    var FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function storeTabindexAndDisable($el) {
        if ($el.data('focusTrapPrevTabindex') !== undefined) return;
        var prev = $el.attr('tabindex');
        $el.data('focusTrapPrevTabindex', prev === undefined ? '' : prev);
        $el.attr('tabindex', '-1');
    }

    function restoreStoredTabindexCollection($collection) {
        $collection.each(function () {
            var $el = $(this);
            if ($el.data('focusTrapPrevTabindex') === undefined) return;
            var prev = $el.data('focusTrapPrevTabindex');
            $el.removeData('focusTrapPrevTabindex');
            if (prev === '') $el.removeAttr('tabindex');
            else $el.attr('tabindex', prev);
        });
    }

    function clearDesktopMenubarTabindexTrap() {
        restoreStoredTabindexCollection($desktopTabindexPatched);
        $desktopTabindexPatched = $();
    }

    function applyDesktopMenubarTabindexTrap($activeLi) {
        clearDesktopMenubarTabindexTrap();
        var $allowed = $activeLi.find(FOCUSABLE_SELECTOR).filter(':visible');
        var allowedArr = $allowed.get();
        $('#menubar').find(FOCUSABLE_SELECTOR).filter(':visible').each(function () {
            if (allowedArr.indexOf(this) >= 0) return;
            var $el = $(this);
            storeTabindexAndDisable($el);
            $desktopTabindexPatched = $desktopTabindexPatched.add($el);
        });
    }

    function handleFocusTrap(e) {
        const isTabPressed = (e.key === 'Tab' || e.keyCode === 9);
        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
                e.preventDefault();
                $(lastFocusableElement).focus();
            }
        } else {
            if (document.activeElement === lastFocusableElement) {
                e.preventDefault();
                $(firstFocusableElement).focus();
            }
        }
    }

    function syncDesktopSubmenuFocusTrap() {
        $('#menubar').off('keydown.desktopSubmenuTrap');
        clearDesktopMenubarTabindexTrap();
        var $open = $('.js-submenu.show').first();
        if (!$open.length) {
            return;
        }
        var itemId = $open.data('item_id');
        var $activeLi = $('#menuitem_' + itemId);
        if (!$activeLi.length) return;
        applyDesktopMenubarTabindexTrap($activeLi);
        var $trapFocusables = $activeLi.find(FOCUSABLE_SELECTOR).filter(':visible');
        var arr = $trapFocusables.get();
        if (arr.length) {
            firstFocusableElement = arr[0];
            lastFocusableElement = arr[arr.length - 1];
            $('#menubar').on('keydown.desktopSubmenuTrap', handleFocusTrap);
        }
    }

    function clearMobileMainmenuTabindexTrap() {
        restoreStoredTabindexCollection($mobileTabindexPatched);
        $mobileTabindexPatched = $();
    }

    function applyMobileMainmenuTabindexTrap() {
        clearMobileMainmenuTabindexTrap();
        $('#mainmenu-mobile').find(FOCUSABLE_SELECTOR).filter(':visible').each(function () {
            if ($(this).closest('.submenu-mobile.show').length) return;
            var $el = $(this);
            storeTabindexAndDisable($el);
            $mobileTabindexPatched = $mobileTabindexPatched.add($el);
        });
    }

    function updateMobileMenuFocusTrapBounds() {
        if (!$body.hasClass('menu-mobile-active')) return;
        if ($body.hasClass('menu-mobile-page-2')) {
            applyMobileMainmenuTabindexTrap();
            var $close = $('#menu-mobile > .js-menutoggle-mobile').first();
            var $sub = $('.submenu-mobile.show').first();
            var ordered = [];
            if ($close.length && $close.is(':visible')) ordered.push($close[0]);
            if ($sub.length) {
                $sub.find(FOCUSABLE_SELECTOR).filter(':visible').each(function () {
                    ordered.push(this);
                });
            }
            firstFocusableElement = ordered[0];
            lastFocusableElement = ordered[ordered.length - 1];
        } else {
            clearMobileMainmenuTabindexTrap();
            var $nodes = $('#menu-mobile').find(FOCUSABLE_SELECTOR).filter(function () {
                var $sm = $(this).closest('.submenu-mobile');
                if ($sm.length && !$sm.hasClass('show')) return false;
                return $(this).is(':visible');
            });
            var arr = $nodes.get();
            firstFocusableElement = arr[0];
            lastFocusableElement = arr[arr.length - 1];
        }
    }

    var $mainMenuItemsWithSubmenu = $("#mainmenu").find("li.menu-item-has-children");
    $mainMenuItemsWithSubmenu.each(function(){
        var $thisItem = $(this);
        var itemId = $thisItem.data('item_id');

        var $thisItemSubmenu = $("#submenu_"+itemId);
        $thisItem.data('submenu', $thisItemSubmenu);
        $thisItemSubmenu.data('mainitem', $thisItem);

        $(this).hover(function(e){
          var itemId = $(this).data('item_id');
          var $currentSubmenu = $("#submenu_"+itemId);

          // Hide all other submenus first
          $('.js-submenu').removeClass('show');
          $mainMenuItemsWithSubmenu.attr('aria-expanded', false);
          $mainMenuItemsWithSubmenu.find('.js-desktop-submenu-button').attr('aria-expanded', false);
          // Show only the current submenu
          $currentSubmenu.addClass('show');
          $(this).attr('aria-expanded', true);
          $(this).find('.js-desktop-submenu-button').attr('aria-expanded', true);
          syncDesktopSubmenuFocusTrap();
        },function(e){
          var itemId = $(this).data('item_id');
          var $currentSubmenu = $("#submenu_"+itemId);

          $currentSubmenu.removeClass('show');
          $(this).attr('aria-expanded', false);
          $(this).find('.js-desktop-submenu-button').attr('aria-expanded', false);
          syncDesktopSubmenuFocusTrap();
        });

        $(this).find('.js-desktop-submenu-button').click(function(e){
            var $li = $(this).closest('li.menu-item-has-children');
            var itemId = $li.data('item_id');
            var $currentSubmenu = $("#submenu_"+itemId);
            const submenuIsVisible = $currentSubmenu.hasClass('show');
            $(".js-submenu").removeClass('show');
            $mainMenuItemsWithSubmenu.find('.js-desktop-submenu-button').attr('aria-expanded', false);
            if(submenuIsVisible) {
                $currentSubmenu.removeClass('show');
                desktopSubmenuReturnFocus = null;
            } else {
                $currentSubmenu.addClass('show');
                $(this).attr('aria-expanded', true);
                desktopSubmenuReturnFocus = this;
            }
            syncDesktopSubmenuFocusTrap();
        });

        $thisItemSubmenu.hover(function(e){
            var submenuItemId = $(this).data('item_id');
            var $mainItem = $("#menuitem_"+submenuItemId);
            $mainItem.addClass('hover');
        },function(e){
            var submenuItemId = $(this).data('item_id');
            var $mainItem = $("#menuitem_"+submenuItemId);
            $mainItem.removeClass('hover');
        });


    });

    $(document).on('keydown.desktopSubmenuEscape', function (e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) return;
        if (!$('.js-submenu.show').length) return;
        $('.js-submenu').removeClass('show');
        $mainMenuItemsWithSubmenu.attr('aria-expanded', false);
        $('.js-desktop-submenu-button').attr('aria-expanded', false);
        $('#menubar').off('keydown.desktopSubmenuTrap');
        clearDesktopMenubarTabindexTrap();
        if (desktopSubmenuReturnFocus) {
            $(desktopSubmenuReturnFocus).focus();
            desktopSubmenuReturnFocus = null;
        }
    });
  
  
  //   function menuShow() {
  //     const menu = $("#menu-mobile");

  //     previouslyFocusedElement = document.activeElement;

  //     focusableContent = menu.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  //     firstFocusableElement = focusableContent[0];
  //   lastFocusableElement = focusableContent[focusableContent.length - 1];

  //   $(firstFocusableElement).focus();
    
  //   console.log(firstFocusableElement);
      

  //     // Remove listener
  //     menu.on('keydown', handleFocusTrap);
  // }

  // function menuHide() {
  //     const menu = $("#menu-mobile");

  //     // Remove listener
  //     menu.off('keydown', handleFocusTrap);

  //     if (previouslyFocusedElement) {
  //         $(previouslyFocusedElement).focus();
  //     }
  // }

    $(".js-menutoggle-mobile").click(function(e){

        if($body.hasClass('menu-mobile-active')){
            if($body.hasClass('menu-mobile-page-2')) {
              $body.removeClass('menu-mobile-page-2');
              $body.removeClass('menu-mobile-active');
              clearMobileMainmenuTabindexTrap();
              $('#mainmenu-mobile').find('.submenu-mobile.show').removeClass('show');
              $('#menu-mobile').off('keydown', handleFocusTrap);
              mobileSubmenuOpenerButton = null;
            }
            else {
              $body.removeClass('menu-mobile-active');
              $body.removeClass('menu-mobile-page-2');
              clearMobileMainmenuTabindexTrap();
              $('#mainmenu-mobile').find('.submenu-mobile.show').removeClass('show');
              $('#menu-mobile').off('keydown', handleFocusTrap);
              mobileSubmenuOpenerButton = null;
            }
          }
          else {
          $body.addClass('menu-mobile-active');

          previouslyFocusedElement = document.activeElement;
          $('#mainmenu-mobile').find('.submenu-mobile.show').removeClass('show');
          $body.removeClass('menu-mobile-page-2');
          clearMobileMainmenuTabindexTrap();
          updateMobileMenuFocusTrapBounds();
          $(firstFocusableElement).focus();
          $('#menu-mobile').on('keydown', handleFocusTrap);

          }
        $(this).attr('aria-expanded', $body.hasClass('menu-mobile-active'));

    });


    $(".js-mobile-submenu-button-back").click(function(e) {
      $body.removeClass('menu-mobile-page-2');
      $('#mainmenu-mobile').find('.submenu-mobile.show').removeClass('show');
      $(this).parent().parent().find('.js-mobile-submenu-button').attr('aria-expanded', false);
      clearMobileMainmenuTabindexTrap();
      updateMobileMenuFocusTrapBounds();
      if (mobileSubmenuOpenerButton) {
        $(mobileSubmenuOpenerButton).focus();
        mobileSubmenuOpenerButton = null;
      }
    });

    $(".closeMobileMenu").click(function(){
        $body.removeClass('menu-mobile-active menu-mobile-page-2');
        clearMobileMainmenuTabindexTrap();
        $('#mainmenu-mobile').find('.submenu-mobile.show').removeClass('show');
        $('#menu-mobile').off('keydown', handleFocusTrap);
        mobileSubmenuOpenerButton = null;
    });


    var $mainMenuMobileItemsWithSubmenu = $("#mainmenu-mobile").find("li.menu-item-has-children");
    $mainMenuMobileItemsWithSubmenu.each(function(){
        var $thisItem = $(this);
        var itemId = $thisItem.data('item_id');
        var $thisItemSubmenu = $("#submenu-mobile_"+itemId);
        $thisItem.find('.js-mobile-submenu-button').click(function(){
          mobileSubmenuOpenerButton = this;
          $body.addClass('menu-mobile-page-2');
          $(this).attr('aria-expanded', true);
            $thisItemSubmenu.addClass('show').siblings().removeClass('show');
          updateMobileMenuFocusTrapBounds();
          var $back = $thisItemSubmenu.find('.js-mobile-submenu-button-back').first();
          if ($back.length) {
            $back.focus();
          } else {
            $thisItemSubmenu.find(FOCUSABLE_SELECTOR).filter(':visible').first().focus();
          }
        });
    });


    /** Show location modal **/
    $(".showLocationModal").click(function(){
        locationModalShow();
    });
    $(".js-show-location-modal").click(function(){
        locationModalShow();
    });
    $(".hideLocationModal").click(function(){
        locationModalHide();
    });
  
    $('#choose_location_modal').hasClass('show') ? locationModalShow() : locationModalHide();

    function locationModalShow() {
      const modal = $(".js-choose_location_modal");

        previouslyFocusedElement = document.activeElement;

      modal.addClass('show');

        focusableContent = modal.find(FOCUSABLE_SELECTOR);
        firstFocusableElement = focusableContent[0];
        lastFocusableElement = focusableContent[focusableContent.length - 1];

        $(firstFocusableElement).focus();

        // Remove listener
        modal.on('keydown', handleFocusTrap);
    }

    function locationModalHide() {
        const modal = $(".js-choose_location_modal");

        modal.removeClass('show');

        // Remove listener
        modal.off('keydown', handleFocusTrap);

        if (previouslyFocusedElement) {
            $(previouslyFocusedElement).focus();
        }
    }

    function onAjaxSetLocation(location) {
        ajax('set-location', { location: location }, function(res) {
            if(typeof afterSetLocation === 'function'){
                afterSetLocation(location);
            } else {
                if(typeof beforeSetLocationReload === 'function'){
                    beforeSetLocationReload(location);
                }

                var currentPageIsHomePagePlaceholder = ($body.hasClass('homepage-placeholder'));

                if (currentPageIsHomePagePlaceholder) {
                    if (location === 'other') window.location.href = '/';
                    else window.location.href = '/' + location + '/';
                }  else {
                    window.location.reload();
                }
            }
        });
    }

    /** Location setter **/
    $(".setLocation").click(function(){
        if($(this).hasClass('selected')) {
             locationModalHide();
             return;
        }

        var location = $(this).data('location');

        if(typeof onSetLocation === 'function'){
            onSetLocation(location);
            return;
        }

        onAjaxSetLocation(location)
    });

    var $stories = $("#stories");
    $stories.each(function(){
        var _thisOwl = $(this).find('.owl-carousel').owlCarousel({
            items: 1,
            loop:true,
            nav: false,
            dots: true,
            autoplay: false,
            autoplayTimeout: 3000
        });

        $(this).find('.nav-left').click(function(){
            _thisOwl.trigger('prev.owl.carousel');
        });

        $(this).find('.nav-right').click(function(){
            _thisOwl.trigger('next.owl.carousel');
        });

    });

    $("select").change(function(){
        $(this).toggleClass('selected', ($(this).val()!==''));
    });

    var $alert = $("#alert");
    if($alert.length) {
        var alertHeight = $alert.outerHeight();
        $alert.css({maxHeight: alertHeight});
    }

    $(".dismissAlert").click(function(){
        $alert.removeClass('show').addClass('hide');
        setCookie('dar_alert_dismissed', true);
    });

    //Cookies
    $("#acceptCookies").click(function() {
        setCookie('dar_ca', true, 365);
        $("#cookie-notice").one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(){
            $(this).remove();
        }).addClass('hide');

    });

    //Kiek = lightbox/fancybox variant
    $("a.image").each(function (idx,anchor) {
        if(anchor.target === '_blank'){
            return;
        }
        $(anchor).kiek({
            transitionSpeed: 150,
            closeText: '',
        });
    });

    var $milieustraatCollapsers = $(".milieustraat-info");
    $milieustraatCollapsers.each(function(){

        $(this).on('shown.bs.collapse', function(){
            if(! $(this).hasClass('googleMapInitialized')) {
                $(this).find('.google-map.milieustraat').initMilieustraatGoogleMap();
                $(this).addClass('googleMapInitialized');
            }
        });
    });

    if($body.hasClass('page-template-template-homepage')) {

        $contentBlocks = $("#main").children('.container');

        setupScrollDownBtn('init');
        $(window).resize(function(ev) {
            setupScrollDownBtn('resize',ev);
        });
        $(window).scroll(function(ev){
            setupScrollDownBtn('scroll',ev)
        });

        $("#scrolldown").click(function() {

            var firstVisible = 0;
            for(var i in contentBlockPositions) {
                var thisCbPos =     contentBlockPositions[i];
                if(thisCbPos > window.scrollY && thisCbPos < window.scrollY + window.innerHeight) {
                    firstVisible = i;
                    break;
                }
            }

            var nextVisibleElemPos = contentBlockPositions[(parseInt(firstVisible)+1)];
            $("html, body").animate({
                scrollTop: (nextVisibleElemPos-48)
            },250);
        });

    }

  smoothScrollAnchorLinks();

  applyCookieConsentWCAGAdditions();
  initializeFlipbookActions();
  addMediaDescription();
  applyRecaptchaWCAGAdditions();
  applyPostContentWCAGAdditions();
});

function setupScrollDownBtn(type,e){

    if(type==='init' || type==='resize') {
        contentBlockPositions = [];
        $contentBlocks.each(function (i, elem) {
            contentBlockPositions.push(($(elem).offset().top));
        });

        //Show scroll down button if second row on home is not visibile
        var secondBlockCbPosY = contentBlockPositions[1];
        $('body').toggleClass('show-scrolldownbtn', ((secondBlockCbPosY+32) > window.innerHeight));

        docHeight = $(document).height();
    }
    if(type==='scroll'){
        if(scrollTimeout) window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(function(){
            $('body').toggleClass('scroll-bottom', (window.scrollY >= (docHeight-(2*window.innerHeight))));
        },40);
    }

}

$.fn.initMilieustraatGoogleMap = function () {

    var _elem = $(this).get(0);
    var data = $(this).data();
    var markerPos = {lat: data.locationLat, lng: data.locationLng};
    var directionsLink = 'https://www.google.com/maps/dir/?api=1&destination='+data.locationLat+','+ data.locationLng;
    var infoContent = '<div style="font-size: 15px; line-height: 1.4"><strong>'+data.locationName+'</strong><br/><a href="'+directionsLink+'" target="_blank">Route</a></div>';


    var map = new google.maps.Map(_elem, {
        zoom: 12,
        center: markerPos
    });
    var infoWindow = new google.maps.InfoWindow({
        content: infoContent,
        disableAutoPan: true
    });

    var icon = {
        url: theme_url+'/assets/dist/img/dar/afvalsoorten-marker/milieustraat.svg',
        size: new google.maps.Size(40, 40),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 40),
        scaledSize: new google.maps.Size(40, 40)
    };

    var marker = new google.maps.Marker({
        position: markerPos,
        map: map,
        icon: icon
    });
    marker.addListener('click', function () {
        infoWindow.open(map, marker);
    });

};


smoothScrollAnchorLinks = function () {
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('[class*="collapse"]')
        .click(function (event) {
            // On-page links
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 250);
                }
            }
        });
};


/**
 * Dearhive Flipbook WCAG additions
 */

function initializeFlipbookActions() {
    //check if dearflip is loaded
    if (!DEARFLIP) {
        return;
    }
  
    DEARFLIP.defaults.onReady = function (df) {
        //Hook into onCreate hook, to apply WCAG additions
        applyFlipbookAltText(df);
    }

    //Hook into onCreateUI hook, to apply WCAG additions
    DEARFLIP.defaults.onCreateUI = function (df) {
        applyFlipbookWCAGAdditions(df);
        // Also try to apply alt text here in case canvas is created later
        applyFlipbookAltText(df);
    }
}

/**
 *  Apply WCAG additions to flipbook instances
 */
function applyFlipbookAltText(df) {
  // Check if dflip_alt exists and has a value
  if (typeof dflip_alt === 'undefined') {
    return;
  }
  
  if (!dflip_alt || dflip_alt.trim() === '') {
    return;
  }
  
  // Try multiple strategies to find canvas elements
  let canvas = $(df.viewer.element).find('canvas');
  
  // If no canvas found in viewer element, try looking in the entire flipbook container
  if (canvas.length === 0) {
    canvas = $(df.element).find('canvas');
  }
  
  // If still no canvas, wait a bit and try again (timing issue)
  if (canvas.length === 0) {
    setTimeout(function() {
      applyFlipbookAltTextDelayed(df);
    }, 500);
    return;
  }
  
  // Apply aria-label to all canvas elements
  canvas.each(function(index) {
    $(this).attr('aria-label', dflip_alt);
    $(this).attr('role', 'img');
  });
}

function applyFlipbookAltTextDelayed(df) {
  let canvas = $(df.viewer.element).find('canvas');
  if (canvas.length === 0) {
    canvas = $(df.element).find('canvas');
  }
  
  if (canvas.length === 0) {
    return;
  }
  
  canvas.each(function(index) {
    $(this).attr('aria-label', dflip_alt);
    $(this).attr('role', 'img');
  });
}

/**
 *  Apply WCAG additions to flipbook instances
 */
function applyFlipbookWCAGAdditions(df) {

    // add "Role" and "aria-pressed" attribute to flipbook controls

    for (const controlKey in df.ui.controls) {

        const $ctrlElement = df.ui.controls[controlKey];
        // add role and aria-pressed to flipbook control elements
        if ($ctrlElement.length > 0 && $ctrlElement.is('div')) {
            $ctrlElement.attr('role', 'button');
            $ctrlElement.attr('aria-pressed', 'false');
            $ctrlElement.attr('tabindex', '0');

            $ctrlElement.on("keydown", function (e) {
              // Check of de focus op een "button-div" staat
              if (
                (e.key === "Enter" || e.key === " ") &&
                e.target.matches("div[role='button'][tabindex]")
              ) {
                e.preventDefault(); // voorkomt dat de pagina scrolt bij spatie
                e.target.click();   // triggert de bestaande click-handlers
              }
            });
        }

        if ($ctrlElement.hasClass('df-ui-page')) {
          const $input = $ctrlElement.find('input');
          const $label = $ctrlElement.find('label');
          
          // Swap the positions of input and label in the DOM
          $label.insertBefore($input);
          
          $label.attr('aria-label', 'Navigeer naar pagina');
        }

        // check if 'more' button is present, and add aria-pressed attribute if activated
        if ($ctrlElement.hasClass('df-ui-more')) {
            observeFlipbookButtonPressed($ctrlElement, 'df-active');
        }
        // check if 'volume' button is present, and add aria-pressed attribute if disabled
        if ($ctrlElement.hasClass('df-icon-volume')) {
            if ($ctrlElement.hasClass('disabled')) {
                $ctrlElement.attr('aria-pressed', 'true');
            }
            observeFlipbookButtonPressed($ctrlElement, 'disabled');
        }
    }
}

function observeFlipbookButtonPressed($ctrlElement, classNameToCheck) {
    const ctrlObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === "class") {
                $ctrlElement.attr('aria-pressed', mutation.target.classList.contains(classNameToCheck));
            }
        });
    });
    ctrlObserver.observe($ctrlElement[0], {attributes: true});
}




  /**
 *  Apply WCAG additions to CookieConsent
 */
  function applyCookieConsentWCAGAdditions() {
    applyCookieConsentButtons();
    applyCookieConsentRevoke();
    setTimeout(() => {
      applyCookieConsentLabels();
    }, 1000);
  }

  function applyRecaptchaWCAGAdditions() {

  }

  function applyCookieConsentLabels() {
    const $cookieWindow = $('.cc-window');

    console.log($cookieWindow);
    const $labels = $cookieWindow.find('.cc-link');
    if ($labels.length > 0) {
      $labels.each(function() {
        console.log($(this));
        $(this).attr('aria-label','Lees meer over cookies');
      });
    }
  }
  
  /**
   *  Replace anchor with buttons to CookieConsent
   */
  function applyCookieConsentButtons() {
    const $cookieWindow = $('.cc-window');
    const $buttons = $cookieWindow.find('.cc-btn');
    if ($buttons.length > 0) {
      $buttons.each(function() {
        var $btn = $(this);
        var $newBtn = $('<button></button>').text($btn.text());
        $.each(this.attributes, function() {
        if (this.specified && this.name !== 'aria-label' && this.name !== 'role') {
          $newBtn.attr(this.name, this.value);
        }
        });
        $btn.replaceWith($newBtn);
      });
    }
  }
  
  /**
   *  Replace revoke div with button to CookieConsent
   */
  function applyCookieConsentRevoke() {
    var $ccRevoke = $('.cc-revoke');
    if ($ccRevoke.length > 0) {
      var $newBtn = $('<button></button>').text($ccRevoke.text());
      $.each($ccRevoke[0].attributes, function() {
        if (this.specified) {
          $newBtn.attr(this.name, this.value);
        }
      });
      $ccRevoke.replaceWith($newBtn);
    }
  }

  function addMediaDescription() {
    let $mediaDescription = $('.js-media-description');
    $mediaDescription.each(function() {
      let $parent = $(this).parents('.wp-video');
      let $descriptionText = $(this).text();

      $parent.find('.wp-video-shortcode').attr('aria-label', $descriptionText);
    });
  }


  function applyPostContentWCAGAdditions() {
    $postContent = $('.text-content');
    if ($postContent.length > 0) {
      $postContent.find("a.image").each(function() {
          $(this).attr('aria-role', 'button');
      });

    };
  }
